import { OrganizationSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const organizationSearchQueryAtom = createQueryAtomFactory(
  'admin.organizationSearch',
  (params: { searchTerm?: string; limit?: number }) => ({
    organizations: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: ['NameAsc' as OrganizationSortOption],
        pagination: {
          limit: params.limit || 15,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        domain: true,
      },
    },
  }),
  {
    select: ({ organizations }) => organizations.entries,
  },
);
